import {ActionsRow, i18n} from 'mc/lib';
import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import {Button, ButtonToolbar, Card, CardBlock, CardHeader} from 'reactstrap';
import Dokument from './Dokument';
import './DokumentList.scss';

export default class DokumentList extends PureComponent {

    static propTypes = {
        dokumentList: PropTypes.array.isRequired,
        onAdd: PropTypes.func,
        onDelete: PropTypes.func,
    };

    setFileInput = fileInput => {
        this.fileInput = fileInput;
    };

    handleNewFile = () => {
        this.fileInput.click();
    };

    handleNewFileOpen = () => {
        const {files} = this.fileInput;
        if (files && files.length === 1) {
            const file = files[0];
            if (file) {
                this.props.onAdd({nazev: file.name, soubor: file});
            }
        }
    };

    renderDokument = (dokument, index) => {
        const {onDelete} = this.props;
        return <Dokument key={index} dokument={dokument} onDelete={onDelete}/>;
    };

    renderActions() {
        const {onAdd} = this.props;
        if (!onAdd) {
            return null;
        }
        return (
            <ButtonToolbar>
                <Button type="button" onClick={this.handleNewFile}>{i18n('global.add')}</Button>
                <input ref={this.setFileInput} className="hidden-xs-up" onChange={this.handleNewFileOpen} type="file" />
            </ButtonToolbar>
        );
    }

    render() {
        const {dokumentList} = this.props;
        return (
            <Card className="dokument-list">
                <CardHeader>
                    <ActionsRow actions={this.renderActions()}>
                        <h5>{i18n('dokument.list')} ({dokumentList.length})</h5>
                    </ActionsRow>
                </CardHeader>
                {dokumentList.length === 0 && (
                    <CardBlock>{i18n('dokument.emptyList')}</CardBlock>
                )}
                {dokumentList.map(this.renderDokument)}
            </Card>
        );
    }

}
